if (!customElements.get('variant-picker')) {
	const {getVariantFromOptionArray} = window.FoxTheme.ProductHelper
	class VariantPicker extends HTMLElement {
		constructor() {
			super()
			this.selectors = {
				container: '[data-variant-picker]',
				variantIdInput: 'input[name="id"]',
				pickerFields: ['[data-picker-field]'],
				optionNodes: ['.variant-picker__option'],
				productSku: '[data-product-sku]',
				productAvailability: '[data-product-availability]',
				shareUrlInput: '[data-share-url]',
			}
			this.container = this.closest(this.selectors.container)
			this.domNodes = queryDomNodes(this.selectors, this.container)
			this.Notification = window.FoxTheme.Notification
            window.clickedOption = null
            window.pdpSetup = false
            
			this.setupData()
            this.updateRecoUi()
            this.checkRecoMeta()
  		}

		async setupData() {

			this.productId = this.container.dataset.productId
			this.sectionId = this.container.dataset.section
			this.productUrl = this.container.dataset.productUrl
			this.productHandle = this.container.dataset.productHandle
			this.section = this.container.closest(`[data-section-id="${this.sectionId}"]`)
			this.variantData = this.getVariantData()
			this.productData = await this.getProductJson(this.productUrl)
			this.disableDefaultVariant = this.container.dataset.disableDefaultVariant === 'true'
			this.productForm = document.getElementById(`product-form-${this.sectionId}`)
			this.maybeUnselectDefaultVariants()
          
			this.enableVariantGroupImages = this.container.dataset.enableVariantGroupImages === "true";
            
            this.variantGroupImages = this.getVariantGroupImageData();

			const selectedVariantId = this.section && this.section.querySelector(this.selectors.variantIdInput).value
			this.currentVariant = this.variantData.find(variant => variant.id === Number(selectedVariantId))
			if (this.currentVariant) {
				this.getDataImageVariant(this.currentVariant.id);
				this.hideSoldOutAndUnavailableOptions()
			}

			this.getMediaGallery();
			this.initOptionSwatches()
			this.addEventListener('change', this.onVariantChange);

            const pickerFields = Array.from(this.querySelectorAll('[data-picker-field]'))
            pickerFields.forEach((pickerField) => {
              pickerField.addEventListener('click', this.onVariantClick);
            })

            this.checkRecoSamples()
            this.checkRecoCollapsibles()
            this.updateCustomSwatches() 
            setTimeout(() => {
              this.updateMedia()
              this.updateSwatches() 
            }, "800");
		}

        onVariantClick() {
            window.clickedOption = this.getAttribute("data-option-name")
        }
      
		maybeUnselectDefaultVariants() {
			if ( ! this.disableDefaultVariant ) return;

			let urlParams = new URLSearchParams( window.location.search );
			if ( urlParams.has('variant') ) return;

			let isVariantChange = false

			this.domNodes.pickerFields && this.domNodes.pickerFields.forEach((pickerField) => {
				let optionName = pickerField.dataset.optionName
				let optionInfo = this.getProductOptionByName( optionName )

				if( optionInfo && optionInfo.values.length > 1 ) {
					isVariantChange = true
					let pickerType = pickerField.dataset.pickerField
					switch( pickerType ) {
						case 'select':
							let selectBox = pickerField.querySelector('select')
							let option = document.createElement('option')
							option.text = this.container.dataset.variantOptionNoneText
							option.setAttribute('disabled', '')
							option.setAttribute('selected', '')
 
							selectBox.add(option, 0);
							break;
						default:
							let checkedInputs = pickerField.querySelectorAll('input:checked')
							checkedInputs && checkedInputs.forEach(function (input) {
								input.removeAttribute('checked')
							});
							break;
					}
					
					pickerField.dataset.selectedValue = ''
					pickerField.querySelector('.selected-value').textContent = ''
				}
			})

			if( isVariantChange ) {
				const variantIdInput = this.section && this.section.querySelector(this.selectors.variantIdInput)
				variantIdInput.value = ''
    
				const formVariantIdInput = this.productForm.querySelector(this.selectors.variantIdInput)
				formVariantIdInput.value = ''
 
				const atcButton = this.productForm.querySelector('[name="add"]')
				const buyNowButton = this.productForm.querySelector('.shopify-payment-button__button')
    
				atcButton.addEventListener( 'click', this.alertVariantSelectionNeeded.bind(this) )
				buyNowButton && buyNowButton.addEventListener( 'click', this.alertVariantSelectionNeeded.bind(this) )
			}
		}

		alertVariantSelectionNeeded( evt ) {
			if ( ! this.disableDefaultVariant ) return;

			if( ! this.currentVariant ) {
				evt.preventDefault()

				// Mark picker field as error.
				this.domNodes.pickerFields && this.domNodes.pickerFields.forEach((pickerField) => {
					if( '' === pickerField.dataset.selectedValue ) {
						pickerField.closest('.variant-picker__field-wrapper').classList.add('is-error')
					}
				})

				// Show a message below form.
				this.Notification.show({
					target: this.productForm,
					method: 'appendChild',
					type: 'warning',
					last: 3000,
					message: this.container.dataset.variantSelectionNeededText
				})
			} else {
				this.Notification.removeNoti()

				this.domNodes.pickerFields && this.domNodes.pickerFields.forEach((pickerField) => {
					if( '' !== pickerField.dataset.selectedValue ) {
						pickerField.closest('.variant-picker__field-wrapper').classList.remove('is-error')
					}
				})
			}
		}

		getProductOptionByName( optionName ) {
			for (var i = 0; i < this.productData.options.length; i++) {
				var option = this.productData.options[i];
				if (option['name'] === optionName) {
				  return option;
				}
			}
			return null;
		}

        camelCase(str) {
            // Using replace method with regEx
            return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
                return index == 0 ? word.toUpperCase() : word.toUpperCase();
            }).replace(/\s+/g, '');
        }


        // Check PDP accordions for empty values and hide if needed
        checkRecoCollapsibles() {
          const collasibles = document.querySelectorAll('.f-product-single .f-product-single__blocks .collapsible__item')
          collasibles.forEach((collasible) => {
            let cContent = collasible.querySelector('.collapsible__content-inner').innerHTML.trim()
            if(cContent == "") {
              collasible.classList.add('hide')
            }
            else {
              collasible.classList.remove('hide')
            }
          });
        }


        // Update the UI dependig on variant selection
        updateRecoUi() {
          const selectionInformation = document.querySelector('#variant-picker-info')
          const materialInformation = document.querySelector('#pdpVariantMaterial .variant-picker__field')
          const panelSizeInformation = document.querySelector('#pdpVariantDimensions .variant-picker__field')
          const panelSizeLabel = document.querySelector('variant-button[data-option-name="Panel Size"] label')

          if(!panelSizeLabel.querySelector('.selected-value-suffix')) {
            panelSizeLabel.innerHTML = panelSizeLabel.innerHTML + '<span class="selected-value-suffix"> (width x height)</span>';
          }
          
          if(selectionInformation !== null) {
            let info = ''
            
            // Material - pull from variant selector and add extra UI info
            const materialVariant = document.querySelector('variant-button[data-option-name="Material"] span.selected-value')
            
            if(materialVariant !== null) {
              let uIText = materialVariant.textContent
              switch(uIText) {
                case 'PVC':
                case 'Polycarb':
                  info = info + '<li class="tick">This product is fire rated for use in bathrooms and kitchens (please see <a style="text-decoration:underline;" href="/pages/technical-specifications">full specifications</a> for details)</li>'
                  break;
                case 'Acrylic':
                  info = info + '<li class="cross">This panel is not for use near heat sources, hobs etc.</li>'
                  break;
                default:
                  // No change
              }
            }

            // Panel size - pull from variant selector and add extra UI info
            const panelSize = document.querySelector('variant-button[data-option-name="Panel Size"] span.selected-value')
            if(panelSize != null) {
              let dimensions = panelSize.textContent.replaceAll("mm","")
              dimensions = dimensions.split("x")
              let panelW = Number(dimensions[0]);
              let panelH = Number(dimensions[1]);
              let orientation = ''
              if(panelW > panelH) {
                orientation = 'Panel orientation: landscape'
              }
              else if(panelW < panelH) {
                orientation = 'Panel orientation: portrait'
              }
              else {
                orientation = 'This panel is made of two halves to make a square'              
              }
              if(orientation != '') info = info + '<li class="tick">'+orientation+'</li>'
            }
            
            // Rotatable panel?
            const panelRotate = document.querySelector('.panel-rotatable')
            if(panelRotate != null) {
              info = info + '<li class="tick">This product may be used in either orientation</li>'
            }

            if(info != "") {
              selectionInformation.classList.add('show')
            }
            else {
              selectionInformation.classList.remove('show')              
            }
            
            info = '<ul>' + info + '</ul>'
            selectionInformation.innerHTML = info

            // Delivery times
            if (typeof quantityDelivery === 'function') {
              let quantityInput = document.querySelector(".f-product-single .f-quantity__input")
              quantityDelivery(quantityInput.value);
            }

            // Product media
            if (typeof productPageMedia === 'function') {
              productPageMedia();
            }
          }
        }
      
        // Update the PDP description and meta values if the variant changes and if a value exists
        checkRecoMeta() {
          const variantIdInput = this.section && this.section.querySelector(this.selectors.variantIdInput)
          const variantIdInputValue = variantIdInput.value
          const descriptionWrapper = document.getElementById('pdpDescription')
          const specsWrapper = document.getElementById('pdpPanelSpecs')
          const fireClassWrapper = document.getElementById('pdpVariantFireRating')
          const dimensionsWrapper = document.getElementById('pdpVariantDimensions')
          const depthWrapper = document.getElementById('pdpVariantDepth')
          const installedDepthWrapper = document.getElementById('pdpVariantInstalledDepth')
          const variantSku = document.getElementById('pdpSku')

          if(typeof variantDataOptions != 'undefined') {
            variantDataOptions.some(function(productVar) {
              if(productVar.variantId == variantIdInputValue) {
                console.log(productVar)
              
                // Description
                if(productVar.variantDescription != '' && descriptionWrapper !== null) {
                  descriptionWrapper.innerHTML = productVar.variantDescription
                }
              
                // Panel specs
                //console.log('hide specs')
                // if(specsWrapper !== null) {
                //   let pdpSpecs = specsWrapper.innerHTML
                //   if(pdpSpecs.trim() == "") {
                //   }
                // }
                
                // Fire rating data
                if(productVar.fireRating != '' && fireClassWrapper !== null) {
                  fireClassWrapper.innerHTML = productVar.fireRating
                }
                
                // Dimensions
                if(productVar.dimensions != '' && dimensionsWrapper !== null) {
                  dimensionsWrapper.innerHTML = productVar.dimensions
                }
              
                // Depth
                if(productVar.variantDepth != '' && depthWrapper !== null) {
                  const depthObj = JSON.parse(productVar.variantDepth);
                  depthWrapper.innerHTML = depthObj.value + depthObj.unit
                }  

                // Installed Depth
                if(productVar.variantInstalledDepth == '' && installedDepthWrapper !== null) installedDepthWrapper.parentElement.classList.add('hidden');
                if(productVar.variantInstalledDepth != '' && installedDepthWrapper !== null) {
                  installedDepthWrapper.parentElement.classList.remove('hidden');
                  const installedDepthObj = JSON.parse(productVar.variantInstalledDepth);
                  installedDepthWrapper.innerHTML = installedDepthObj.value + installedDepthObj.unit;

                  if(installedDepthObj.value == 0 || installedDepthObj.value == '') installedDepthWrapper.parentElement.classList.add('hidden');
                }

                // SKU
                if(productVar.sku != '' && variantSku !== null) {
                  variantSku.innerHTML = productVar.sku
                } 
              
                return;
              }
            });
          }
          
          this.updateRecoUi()
        }

        
      

        // Update the PDP samples section if a sample match is found, otherwise display fallback sample pack
        checkRecoSamples() {
          const sampleElm = document.getElementById('sample');
          const sampleTriggerBtn = document.getElementById('sample-trigger-button');
          const sampleBestSellersTriggerBtn = document.getElementById('sample-best-sellers-trigger-button');
          const fallback = "retail-sample-pack"
          
          if(sampleElm !== null) {
            const variantIdInput = this.section && this.section.querySelector(this.selectors.variantIdInput)
            const variantIdInputValue = variantIdInput.value
            const productSku = this.section && this.section.querySelector(this.selectors.productSku)

            let sku = fallback;
            this.variantData.some(function(productVar) {
              if(productVar.id == variantIdInputValue) {
                sku = productVar.sku + '-sample'

                // handelize the sku
                sku = sku.toLowerCase()
                
                // Remove -half if present
                sku = sku.replace("-half", "")
                
                sku = sku.replace(/\W+/g, "-");
                if (sku.charAt(sku.length - 1) == "-") {
                    sku = sku.replace(/-+\z/, "");
                }
                if (sku.charAt(0) == "-") {
                    sku = sku.replace(/\A-+/, "");
                }
                return;
              }
            });

            // Backup is a match on the mould in white
            const backupArray = sku.split('-')
            let backupSku = ''
            const backupArrayTot = backupArray.length
            for(let b=0; b<backupArrayTot; b++) {
              if(backupSku !== '') backupSku = backupSku + '-'
              if(b == backupArrayTot - 3 || b == backupArrayTot - 2) {
                backupSku = backupSku + 'wt'
              }
              else {
                backupSku = backupSku + backupArray[b]
              }
            }

            // EFX override
            // All EFX glass products use the same sample
            if(sku.includes('gls-a-')) {
              sku = 'gls-a-sample';
            }
            
            // Find a matching sample SKU
            let sampleMatch = document.getElementById(sku)
            

            // Switch to mould match sample SKU
            if(sampleMatch === null) {
              sampleMatch = document.getElementById(backupSku)
              console.log("Backup sample used: White version of the current tile")
            }
            
            if(sampleMatch !== null) {
              // Hide any showing sample
              const liveSampleMatch = document.querySelector('.sample-form.show')
              if(liveSampleMatch !== null) {
                liveSampleMatch.classList.add('hide')
                liveSampleMatch.classList.remove('show')
              }
              sampleMatch.classList.add('show')
              sampleMatch.classList.remove('hide')
              if(sampleBestSellersTriggerBtn != null && sampleTriggerBtn != null) {
                sampleBestSellersTriggerBtn.classList.add('hidden')
                sampleTriggerBtn.classList.remove('hidden')
              }
            }
            else {
              // Revert to fallback sample pack
              const liveSampleMatch = document.querySelector('.sample-form.show')
              if(liveSampleMatch !== null) {
                liveSampleMatch.classList.add('hide')
                liveSampleMatch.classList.remove('show')
              }
              const sampleMatch = document.getElementById(fallback)
              if(sampleMatch !== null) { 
                sampleMatch.classList.add('show')
                sampleMatch.classList.remove('hide')
              }
              if(sampleBestSellersTriggerBtn != null && sampleTriggerBtn != null) {
                sampleBestSellersTriggerBtn.classList.remove('hidden')
                sampleTriggerBtn.classList.add('hidden')
              }
            }
          }
        }

        // When switching between variants check the permitted js object to check what is permitted for retail customers
        checkRecoMatrix() {
          
          // B2B product check
          if(typeof variantAllowedMatrix !== "undefined") {
            let justClicked = ''
            
            const pickerFields = Array.from(this.querySelectorAll('[data-picker-field]'))
            this.options = pickerFields.map((field) => {
				const type = field.dataset.pickerField
				if (type === 'radio') {
					let checkedRadio = Array.from(field.querySelectorAll('input')).find((radio) => radio.checked)
					return checkedRadio ? checkedRadio.value : ''
				}
			})

            // Setup variant grouping indexes
            let countI = 0;
            var variantIndexes = {};
            for (var key of Object.keys(variantAllowedMatrix[0])) {
              variantIndexes[key] = countI
              if(countI == 0) justClicked = key // fallback
              countI = countI + 1
            }

            // Hide everything other than the justclicked group and use the filter to reveal 
            let allVariants = document.querySelectorAll('.variant-picker__option:not(.custom-option)')
            let allVariantsTot = allVariants.length
            for (let i = 0; i < allVariantsTot; i++) {
              if(allVariants[i].querySelector('input') && allVariants[i].querySelector('input').getAttribute("name") != window.clickedOption) {
                allVariants[i].classList.add('hide');
              }
			}

            // Show what can be selected otherwise use fallback above
            if(window.clickedOption != null) {
              justClicked = this.camelCase(window.clickedOption)
            }

            // Fiter allowed by what was just selected
            var permittedVariantsRaw = variantAllowedMatrix.filter(obj => {
              return obj[justClicked] === this.options[variantIndexes[justClicked]]
            })
            var permittedVariants = []
            permittedVariantsRaw.forEach((thisVariant) => {
              let addThisVariant = false
              for (const thisOption in this.options) {
                if(thisOption != variantIndexes[justClicked]) {
                  if(Object.values(thisVariant).indexOf(this.options[thisOption]) >= 0) {
                    addThisVariant = true
                  }
                }
              }
              if(addThisVariant == true) {
                permittedVariants.push(thisVariant)
              }
            })
                       

            let permittedVariantsTot = permittedVariants.length
            pickerFields.forEach((pickerField) => {
              let thisVariantName = this.camelCase(pickerField.getAttribute("data-option-name"))
              if(thisVariantName != justClicked) {
                for (let p = 0; p < permittedVariantsTot; p++) {
                  pickerField.querySelector('[data-value="'+permittedVariants[p][thisVariantName]+'"]').classList.remove('hide');
                }
              }
            })

            // Clean up any selected and hidden variant options
            let hiddenCheckedVariants = document.querySelectorAll('.variant-picker__option.hide input:checked')
            let hiddenTot = hiddenCheckedVariants.length
            for (let h = 0; h < hiddenTot; h++) {
              hiddenCheckedVariants[h].checked = false;
              hiddenCheckedVariants[h].closest('.variant-picker__field').setAttribute('data-selected-value', '')
            }
            
            // # Debug
            // console.log(variantAllowedMatrix)
            // console.log('Just clicked: '+justClicked)
            // console.log("Selected options:")
            // console.log(this.options)
            // console.log("Allowed options:")
            // console.log(variantAllowedMatrix)
            // console.log('Variant indexes')
            // console.log(variantIndexes)
            // console.log("---")
            // console.log("permittedVariants:")
            // console.log(permittedVariants)
          }
        }

        updateCustomSwatches() {
          const swatchWrapper = document.querySelector('.custom-product-colour-selector')
          if(swatchWrapper != null) {
            const customSwatches = swatchWrapper.querySelectorAll('.variant-picker__option')
            const swatchTot = customSwatches.length
            const {colorSwatches = []} = window.FoxThemeSettings

            for (let s = 0; s < swatchTot; s++) {
              let sColour = customSwatches[s].getAttribute("data-fallback-value")

              const check = colorSwatches.find(({ key }) => key === sColour);
              const customColor = check ? check.value : ''
              if(typeof check !== 'undefined') {
                customSwatches[s].setAttribute("style", '--option-color: '+check.value+';')
              }
              else {
                // try custom image
                let swatchFileName = sColour.replaceAll(" ", "-").toLowerCase()
                let swatchUrl = '/cdn/shop/files/' + swatchFileName + '.png'
                customSwatches[s].querySelector('.variant-picker__option-button').setAttribute("style", `background-image: url(${ getSizedImageUrl(swatchUrl, '60x')}) !important;`);
              }
            }
          }
        }
      
        updateSwatches () {
            const swatchGrout = document.querySelector('.swatch.swatch--grout')
            const swatchPanel = document.querySelector('.swatch.swatch--panel')
            const panelSizeIndicator = document.querySelector('.panel-size-indicator')

            if(panelSizeIndicator) {
              let sizeSelection = document.querySelector('variant-button[data-option-name="Panel Size"]')
              if(sizeSelection) {
                let selectedSize = sizeSelection.getAttribute("data-selected-value")
                panelSizeIndicator.className = 'panel-size-indicator panel-size-'+selectedSize;
              }
            }
          
            if(swatchGrout && swatchPanel) {

              // Grout
              let groutSelection = document.querySelector('variant-color[data-option-name="Grout Colour"]')
              if(groutSelection) {
                swatchGrout.classList.remove('hide')
                let selectedGrout = groutSelection.getAttribute("data-selected-value")
                let selectedOption = groutSelection.querySelector('.variant-picker__option[data-value="'+selectedGrout+'"]')

                if(selectedOption) {
                  let selectedStyle = selectedOption.getAttribute("style")
                  swatchGrout.setAttribute("style", selectedStyle)
                  swatchGrout.classList.add('show')
                }
              }

              // Panel
              const {colorSwatches = []} = window.FoxThemeSettings
              let panelColour = swatchPanel.getAttribute("data-value")
              if(typeof panelColour !== 'undefined') {
                const check = colorSwatches.find(({ key }) => key === panelColour.toLowerCase());
                const customColor = check ? check.value : ''
                if(typeof check !== 'undefined') {
                  swatchPanel.setAttribute("style", '--option-color: '+check.value+';')
                  swatchPanel.classList.add('show')
                }
              }

              // Tile colour
              let tileColourSelection = document.querySelector('variant-color[data-option-name="Tile Colour"]')
              if(tileColourSelection) {
                let selectedtileColour = tileColourSelection.getAttribute("data-selected-value")
                let selectedOption = tileColourSelection.querySelector('.variant-picker__option[data-value="'+selectedtileColour+'"]')
                //console.log(selectedOption)
                if(selectedOption) {
                  let selectedStyle = selectedOption.getAttribute("style")
                  swatchPanel.setAttribute("style", selectedStyle)

                  // look for image
                  // let selectedLabel = selectedOption.querySelector('.variant-picker__option-button')
                  // if(selectedLabel) {
                  //   let imageStyle = selectedLabel.getAttribute("style")
                  //   swatchPanel.setAttribute("style", imageStyle)
                  // }
                  swatchPanel.classList.add('show')
                }
              }
            }
        }

		onVariantChange() {
			this.getSelectedOptions()
			this.getSelectedVariant()
			this.updateButton(true, '', false)
			this.updatePickupAvailability()
			this.removeErrorMessage()
			this.alertVariantSelectionNeeded()

			if (!this.currentVariant) {
				this.updateButton(true, '', true)
				this.setUnavailable()
			} else {
				this.getDataImageVariant(this.currentVariant.id);
				this.updateMedia()
				this.updateBrowserHistory()
				this.updateVariantInput()
				this.updateProductMeta()
				this.updatePrice()
				this.updateShareUrl()
				this.updateButton(!this.currentVariant.available, window.FoxThemeStrings.soldOut)
				this.hideSoldOutAndUnavailableOptions()
			}

			window.FoxThemeEvents.emit(`${this.productId}__VARIANT_CHANGE`, this.currentVariant, this)
            this.checkRecoMatrix(this)
            this.checkRecoSamples()
            this.checkRecoMeta()
            this.checkRecoCollapsibles()
            this.updateSwatches()
		}

		getMediaGallery() {
			this.mediaGallery = this.section.querySelectorAll('media-gallery');
			this.check = setInterval(() => {
			  if (this.mediaGallery) {
				this.mediaGallery.forEach((media) => {
				  if (window.getComputedStyle(media).display !== 'none' && media.mediaLayout) {
					clearInterval(this.check);
					this.media = media;

					this.allMediaIds = this.media.domNodes.medias && this.media.domNodes.medias.map((item) => {
						return item.dataset.mediaId;
					})
					this.lastVariantMedia = this.allMediaIds

					if ((this.enableVariantGroupImages && this.variantGroupImages.enable)) {
					  this.updateMedia();
					}
				  }
				});
			  }
			}, 100);
		}

		getDataImageVariant(variantId) {
			if (this.variantGroupImages && this.variantGroupImages.enable) {
			  let groupImages = this.variantGroupImages.mapping.find(
				(variant) => Number(variant.id) === variantId
			  )
			  this.currentVariantMedia = groupImages ? groupImages.media : this.allMediaIds
			}
		}

		getProductJson(productUrl) {
			return fetch(productUrl + '.js').then(function (response) {
				return response.json()
			})
		}
		getSelectedVariant() {
			let variant = getVariantFromOptionArray(this.productData, this.options)
			let options = [...this.options]
			if (!variant) {
				options.pop()
				variant = getVariantFromOptionArray(this.productData, options)
				if (!variant) {
					options.pop()
					variant = getVariantFromOptionArray(this.productData, options)
				}
				if (variant && variant.options) {
					this.options = [...variant.options]
				}
				this.updateSelectedOptions()
			}
			this.currentVariant = variant
		}

		getSelectedOptions() {
			const pickerFields = Array.from(this.querySelectorAll('[data-picker-field]'))
			this.options = pickerFields.map((field) => {
				const type = field.dataset.pickerField
				if (type === 'radio') {
					let checkedRadio = Array.from(field.querySelectorAll('input')).find((radio) => radio.checked)
					return checkedRadio ? checkedRadio.value : ''
				}
				return field.querySelector('select') && field.querySelector('select').value
			})
		}

		updateSelectedOptions() {
			this.domNodes.pickerFields.forEach((field, index) => {
				const selectedValue = field.dataset.selectedValue
				if (selectedValue !== this.options[index]) {
					const selectedOption = field.querySelector(`input[value="${this.options[index]}"]`)
					if (selectedOption) {
						selectedOption.checked = true
						field.updateSelectedValue()
					}
				}
			})
		}

		updateMedia() {
            
			if (!this.currentVariant) {
				this.media.removeAttribute('data-media-loading')
				return
			}

			if (!this.media) return;

			let mediaComponent = this.media.querySelector('.f-product__media-list'),
				sliderContainer = mediaComponent.querySelector('.flickity-slider');

  			if (this.variantGroupImages && this.media.domNodes.medias) {

              let featuredImagId = '';
              this.variantGroupImages.forEach((mediaImg) => {
                if(typeof mediaImg.featured_media != 'undefined' && mediaImg.id == this.currentVariant.id) {
                  featuredImagId = mediaImg.featured_media.id
                }
              });

              let mediaToShow = this.media.domNodes.medias;

              // 
              // Rearrange the media order
              if( sliderContainer ) { // Carousel or mobile slider
                  
                const mainFlickity = window.FoxTheme.Flickity.data(mediaComponent);
                
                let showSlide = 0;
                mediaToShow.forEach(function(slide) {
                  if(slide.getAttribute('id') == 'f-product__media-'+featuredImagId) {
                    mainFlickity.select(showSlide);
                  }
                  showSlide = showSlide + 1
                });
                mediaComponent.classList.add('show');
              }
              else {
                mediaToShow.forEach((item) => {
                    if(item.getAttribute('id') == 'f-product__media-'+featuredImagId) {
                      mediaComponent.prepend(item);
                    }
                });
                  mediaComponent.classList.add('show');
              }
                
/* original
  if( ! this.areArraysIdentical(this.currentVariantMedia, this.lastVariantMedia) ) { // Do nothing if media has the same items.
    if( sliderContainer ) { // Carousel or mobile slider.
        const mainFlickity = window.FoxTheme.Flickity.data(mediaComponent);

        let mediaToRemove = mediaComponent.querySelectorAll('.f-product__media');
        mediaToRemove && mediaToRemove.forEach(function(slide) {
            mainFlickity.remove(slide);
        });
        let mediaToShow = this.filteredMediaForSelectedVariant(this.media.domNodes.medias);
        mediaToShow.forEach(function(slide) {
            mainFlickity.append(slide);
        });

        let thumbnailsComponent = this.media.querySelector('.f-product__media-thumbnails');
        if( thumbnailsComponent && this.media.domNodes.thumbnailItems ) {
            const thumbnailsFlickity = window.FoxTheme.Flickity.data(thumbnailsComponent);

            let thumbsToRemove = thumbnailsComponent.querySelectorAll('.f-product__media-thumbnails-item');
            thumbsToRemove && thumbsToRemove.forEach(function(slide) {
                thumbnailsFlickity.remove(slide);
            });

            let thumbsToShow = this.filteredMediaForSelectedVariant(this.media.domNodes.thumbnailItems);
            thumbsToShow.forEach(function(slide) {
                thumbnailsFlickity.append(slide);
            });
        
            thumbnailsComponent.classList.remove('disable-transition', 'md:disable-transition')
            if( thumbsToShow.length < 5 ) {
                thumbnailsComponent.classList.add('disable-transition')
            }
            if( thumbsToShow.length < 6) {
                thumbnailsComponent.classList.add('md:disable-transition')
            }
            thumbnailsFlickity.option({wrapAround: thumbsToShow.length > 5 })
            thumbnailsFlickity.reloadCells()
            thumbnailsFlickity.reposition()
        }

        mainFlickity.select(0, false, false);
    } else { // Grid layouts.
        let mediaToShow = this.filteredMediaForSelectedVariant(this.media.domNodes.medias);
        mediaComponent.innerHTML = '';
        mediaToShow.forEach((item) => {
            mediaComponent.append(item);
        });
    }
    

    // Re-init Photoswipe
    if( this.media && this.media.enableZoom ) {
        this.media.lightbox && this.media.lightbox.destroy();
        this.media.initImageZoom();
    }
}

this.media.removeAttribute('data-media-loading')
this.lastVariantMedia = this.currentVariantMedia

*/
			} else {
				if (!this.currentVariant.featured_media) return
				const mediaGallery = this.section.querySelector('media-gallery')
				mediaGallery && mediaGallery.setActiveMedia(this.currentVariant.featured_media.id)
			}
		}

		areArraysIdentical(array1, array2) {
			if( typeof array1 !== typeof array2 ) {
				return false;
			}

			array1 = typeof array1 === 'object' ? array1 : [];
			array2 = typeof array2 === 'object' ? array2 : [];

			if (array1.length !== array2.length) {
				return false;
			}
			
			const sortedArray1 = array1.slice().sort();
			const sortedArray2 = array2.slice().sort();
			
			for (let i = 0; i < sortedArray1.length; i++) {
				if (sortedArray1[i] !== sortedArray2[i]) {
					return false;
				}
			}

			return true;
		}

		filteredMediaForSelectedVariant(items) {
			let index = 0;
			let results = [];
			items.forEach((item) => {
				const dataIdMedia = item.dataset.mediaId;
				if (this.currentVariantMedia && this.currentVariantMedia.length > 0) {
					if (this.currentVariantMedia.includes(dataIdMedia)) {
						item.dataset.index = index++;
						results.push(item);
					}
     
					if (item.dataset.mediaType !== 'image') {
						item.dataset.index = index++;
						results.push(item);
					}
				} else {
					item.dataset.index = index++;
					results.push(item);
				}
			});

			return results;
		}

		getVariantGroupImageData() {
			this.variantGroupImages = this.variantGroupImages || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
			return this.variantGroupImages;
		}

		updateBrowserHistory() {
			if (!this.currentVariant || this.dataset.updateUrl === 'false') return
			window.history.replaceState({}, '', `${this.productUrl}?variant=${this.currentVariant.id}`)
		}

		updateShareUrl() {
			const url = `${window.location.origin}${this.productUrl}?variant=${this.currentVariant.id}`
			const shareUrlInput = document.querySelectorAll(this.selectors.shareUrlInput)
			shareUrlInput && shareUrlInput.forEach(input => input.setAttribute('value', url))
		}

		updateVariantInput() {
			const productForms = document.querySelectorAll(`#product-form-${this.sectionId}, #product-form-installment`)
			productForms.forEach((productForm) => {
				const variantIdInput = productForm.querySelector(this.selectors.variantIdInput)
				variantIdInput.value = this.currentVariant.id
				variantIdInput.dispatchEvent(new Event('change', {bubbles: true}))
			})
		}

		updatePickupAvailability() {
			const pickUpAvailability = this.section && this.section.querySelector('pickup-availability')
			if (!pickUpAvailability) return

			if (this.currentVariant && this.currentVariant.available) {
				pickUpAvailability.fetchAvailability(this.currentVariant.id)
			} else {
				pickUpAvailability.removeAttribute('available')
				pickUpAvailability.innerHTML = ''
			}
		}

		removeErrorMessage() {
			const section = this.closest('section')
			if (!section) return

			const productForm = section.querySelector('product-form')
			// if (productForm) productForm.handleErrorMessage()
		}

		updatePrice() {
			console.log('updatePrice 2')
			const classes = {
				onSale: 'f-price--on-sale',
				soldOut: 'f-price--sold-out'
			}
			const selectors = {
				priceWrapper: '.f-price.f-price--large',
				salePrice: ['.f-price.f-price--large .f-price-item--sale'],
				compareAtPrice: ['.f-price.f-price--large .f-price-item--regular'],
				unitPrice: '.f-price__unit',
				saleBadge: '.f-price__badge-sale',
				saleAmount: '[data-sale-value]'
			}
			const money_format = window.FoxThemeSettings.money_format
			const {
				priceWrapper,
				salePrice,
				unitPrice,
				compareAtPrice,
				saleBadge,
				saleAmount
			} = queryDomNodes(selectors, this.section)

			const {compare_at_price, price, unit_price_measurement} = this.currentVariant

			const onSale = compare_at_price && compare_at_price > price
			const soldOut = !this.currentVariant.available

			if (onSale) {
				priceWrapper.classList.add(classes.onSale)
			} else {
				priceWrapper.classList.remove(classes.onSale)
			}

			if (soldOut) {
				priceWrapper.classList.add(classes.soldOut)
			} else {
				priceWrapper.classList.remove(classes.soldOut)
			}

			if (priceWrapper) priceWrapper.classList.remove('visibility-hidden')
			if (salePrice) {
				salePrice.forEach(item => item.innerHTML = formatMoney(price, money_format))
			}
			if (compareAtPrice && compareAtPrice.length && compare_at_price > price) {
				compareAtPrice.forEach(item => item.innerHTML = formatMoney(compare_at_price, money_format))
			} else {
				compareAtPrice.forEach(item => item.innerHTML = formatMoney(price, money_format))
			}

			if (saleBadge && compare_at_price > price) {
				const type = saleBadge.dataset.type
				if (type === 'text') return
				let value
				if (type === 'percentage') {
					const saving = (compare_at_price - price) * 100 / compare_at_price
					value = Math.round(saving) + '%'
				}
				if (type === 'fixed_amount') {
					value = formatMoney(compare_at_price - price, money_format)
				}

				saleAmount.textContent = value
			}

			if (unit_price_measurement && unitPrice) {
				unitPrice.classList.remove('f-hidden')
				const unitPriceContent = `<span>${formatMoney(this.currentVariant.unit_price, money_format)}</span>/<span data-unit-price-base-unit>${this._getBaseUnit()}</span>`
				unitPrice.innerHTML = unitPriceContent
			} else {
				unitPrice.classList.add('f-hidden')
			}
		}

		_getBaseUnit() {
			return this.currentVariant.unit_price_measurement.reference_value === 1
				? this.currentVariant.unit_price_measurement.reference_unit
				: this.currentVariant.unit_price_measurement.reference_value +
				this.currentVariant.unit_price_measurement.reference_unit
		}

		updateButton(disable = true, text, modifyClass = true) {
			const productForm = document.getElementById(`product-form-${this.sectionId}`)
			if (!productForm) return
			const addButton = productForm.querySelector('[name="add"]')
			const addButtonText = productForm.querySelector('[name="add"] > span:not(.f-icon)')

			if (!addButton) return

			if (disable) {
				addButton.setAttribute('disabled', 'disabled')
				if (text) addButtonText.textContent = text
			} else {
				addButton.removeAttribute('disabled')
				addButtonText.textContent = window.FoxThemeStrings.addToCart
			}
		}

		updateProductMeta() {
			const {available, sku, noSku} = this.currentVariant
			const {inStock, outOfStock} = window.FoxThemeStrings
			const productAvailability = this.section && this.section.querySelector(this.selectors.productAvailability)
			const productSku = this.section && this.section.querySelector(this.selectors.productSku)

			if (productSku) {
				if (sku) {
					productSku.textContent = sku
				} else {
					productSku.textContent = noSku
				}
			}

			if (productAvailability) {
				if (available) {
					productAvailability.textContent = inStock
					productAvailability.classList.remove('out-of-stock')
				} else {
					productAvailability.textContent = outOfStock
					productAvailability.classList.add('out-of-stock')
				}
			}
		}

		setUnavailable() {
			const button = document.getElementById(`product-form-${this.sectionId}`)
			const addButton = button.querySelector('[name="add"]')
			const addButtonText = button.querySelector('[name="add"] > span:not(.f-icon)')
			const priceWrapper = this.section.querySelector('.f-price')
			if (!addButton) return
			addButtonText.textContent = window.FoxThemeStrings.unavailable
			if (priceWrapper) priceWrapper.classList.add('visibility-hidden')
		}

		hideSoldOutAndUnavailableOptions() {
			const classes = {
				soldOut: 'variant-picker__option--soldout',
				unavailable: 'variant-picker__option--unavailable'
			}
			const variant = this.currentVariant
			const {optionNodes} = this.domNodes
			const {
				productData,
				productData: {variants, options: {length: maxOptions}}
			} = this

			optionNodes.forEach(optNode => {
				const {optionPosition, value} = optNode.dataset
				const optPos = Number(optionPosition)
				const isSelectOption = optNode.tagName === 'OPTION'

				let matchVariants = []
				if (optPos === maxOptions) {
					const optionsArray = Array.from(variant.options)
					optionsArray[maxOptions - 1] = value
					matchVariants.push(getVariantFromOptionArray(productData, optionsArray))
				} else {
					matchVariants = variants.filter(v => v.options[optPos - 1] === value && v.options[optPos - 2] === variant[`option${optPos - 1}`])
				}

				matchVariants = matchVariants.filter(Boolean)
				if (matchVariants.length) {
					optNode.classList.remove(classes.unavailable)
					isSelectOption && optNode.removeAttribute('disabled')
					const isSoldOut = matchVariants.every(v => v.available === false)
					const method = isSoldOut ? 'add' : 'remove'
					optNode.classList[method](classes.soldOut)
				} else {
					optNode.classList.add(classes.unavailable)
					isSelectOption && optNode.setAttribute('disabled', 'true')
				}
			})
		}


		getVariantData() {
			this.variantData = this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent)
            return this.variantData
		}

		initOptionSwatches() {
			const {colorSwatches = []} = window.FoxThemeSettings
			this.domNodes.optionNodes.forEach(optNode => {
				let variantImage
				const {optionPosition, value, fallbackValue, optionType, hasCustomImage} = optNode.dataset
				if (optionType === 'color') {
					const variant = this.variantData.find(v => v[`option${optionPosition}`] && v[`option${optionPosition}`].toLowerCase() === value.toLowerCase())
					const check = colorSwatches.find(c => c.key.toLowerCase() === value.toLowerCase())
					const customColor = check ? check.value : ''


					if (variant && optionType === 'color' && hasCustomImage !== 'true') {
						variantImage = variant.featured_image ? variant.featured_image.src : ''
						//if (variantImage && !customColor) {
						if (!customColor) {
                            let swatchFileName = value.replaceAll(" ", "-").toLowerCase()
                            let swatchUrl = '/cdn/shop/files/' + swatchFileName + '.png'
							//optNode.querySelector('label').style = `background-image: url(${ getSizedImageUrl(variantImage, '60x')}) !important;`
							optNode.querySelector('label').style = `background-image: url(${ getSizedImageUrl(swatchUrl, '60x')}) !important;`
						}
					}

					if (customColor) {
						optNode.style.setProperty('--option-color', `${customColor}`)
					}

					if (!customColor && !variantImage) {
						optNode.style.setProperty('--option-color', `${fallbackValue}`)
					}

                    //optNode.style.setProperty('display', "none")
					return false;
				}
			})
		}
	}

	customElements.define('variant-picker', VariantPicker)
}
if (!customElements.get('variant-button')) {
	class VariantButton extends HTMLElement {
		constructor() {
			super()
			this.selectedSpan = this.querySelector('.selected-value')
			this.addEventListener('change', this.updateSelectedValue)
		}

		updateSelectedValue() {
			this.value = Array.from(this.querySelectorAll('input')).find((radio) => radio.checked).value
			this.setAttribute('data-selected-value', this.value)
			if (this.selectedSpan) this.selectedSpan.textContent = this.value
		}
	}

	customElements.define('variant-button', VariantButton)

	if (!customElements.get('variant-select')) {
		class VariantSelect extends VariantButton {
			constructor() {
				super()
			}

			updateSelectedValue() {
				this.value = this.querySelector('select').value
				this.setAttribute('data-selected-value', this.value)
				if (this.selectedSpan) this.selectedSpan.textContent = this.value
			}
		}

		customElements.define('variant-select', VariantSelect)
	}
	if (!customElements.get('variant-image')) {
		class VariantImage extends VariantButton {
			constructor() {
				super()
			}
		}

		customElements.define('variant-image', VariantImage)
	}
	if (!customElements.get('variant-color')) {
		class VariantColor extends VariantButton {
			constructor() {
				super()
			}
		}
		customElements.define('variant-color', VariantColor)
	}
}
